export default __webpack_public_path__ + "static/media/water-treatment-chemicals.bfd69b57.png";